import cn from "classnames";

import "./index.scss";

interface IButton {
  className?: string;
  children: React.ReactNode;
}

const Button = ({ className, children, ...rest }: IButton) => {
  const classes = cn(["button", className]);

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
};

export default Button;
